/* eslint-disable react/jsx-pascal-case */
import {
    Col, Form, Input, Row, Select, DatePicker, Switch
} from "./../../ui/ot";
import { useKeyword } from "../../keyword/controller/KeywordController";
import { useMesaageTemplate } from "../../mesaage_template/controller/MesaageTemplateController";
import { useAutoReply } from "../../auto_reply/controller/AutoReplyController";
import React, { useEffect } from "react";

const NoReplyForm = (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const [form] = Form.useForm();

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }
    const {
        getAutoReplyOption,
        autoReplyOption
    } = useAutoReply({
        onFinish: () => { },
        onBefore: () => { },
    })
    const {
        getMesaageTemplateOption,
        mesaageTemplateOption
    } = useMesaageTemplate({
        onFinish: () => { },
        onBefore: () => { },
    })
    useEffect(() => {
        setDataInitialization()
        getMesaageTemplateOption()
        getAutoReplyOption()
    }, [])

    useEffect(() => {

        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>

                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"no_reply_id"}
                                name={"no_reply_id"}
                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"no_reply_id"}
                                name={"no_reply_id"}
                            >
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                // hidden={true}
                                label={"訊息內容"}
                                name={"content"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"訊息樣板"}
                                name={"autoreply_id"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Select
                                    options={autoReplyOption.filter(tmp => tmp.autoreply_name !== "手動回覆")}
                                >
                                </Select>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Col>
        </Row>
    )
}



export default NoReplyForm;
